export const customStyles =  {
    rows: {
        style: {
            borderBottomColor: '#FDECEF !important',
            maxHeight: '52px',
            minHeight: '56px',
            lineHeight: '56px',
            fontFamily: "Inter",
            fontWeight: 400,
            fontSize: 15,
            color: 'rgba(0, 0, 0, 0.87)',
        },
    },
    headRow: {
        style: {
            borderBottomColor: '#FDECEF',
        }
    },
    headCells: {
        style: {
            fontFamily: "Inter",
            fontWeight: 400,
            fontSize: 16,
            color: 'rgba(0, 0, 0, 0.87)',
            backgroundColor: 'white',
        },
    },
    cells: {
        style: {
            // Transparent so row-level styling (e.g. conditionalRowStyles
            // banding) can show through; rows render white by default, so
            // this is visually identical everywhere else.
            backgroundColor: 'transparent',
        }
    }
  }
